<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal15" :class="type == 2 ? 'modal-mask' : 'modal-mask1'" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop  style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"  style="color: #6c757d !important;"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png"  />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body" style="min-height: 700px;">
              <div class="modal_reps_to_review d-none-">


                <div class="row mb-2 mt-3">
                  <div class="col-6 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">{{ menteeShortName }}</div>
                    <button class="text-uppercase btn btn-primary d-none mentee_title_btn">Apprentice</button>
                  </div>
                  <div class="col-6 pr-4 text-right">
                    <div class="text-muted">Mentor(s)</div>
                    <ul class="list-inline">
                      <li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
                    </ul>                
                  </div>              
                </div>

                <div>
                  <div class="mt-1 mb-3 pl-3 pr-3">
                    <div class="row align-items-end">
                      <div class="col px-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
                        <p class="text-uppercase mb-1 " 
                          :class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" >
                          <span :style="activeStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                        </p>
                        <div class="progress progress_pathway">
                          <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                        </div>
                      </div>        
                    </div>
                  </div>
                </div>



                <div class="row mx-2 mb-3">
                  <div class="col p-0" style="font-size: 18px; font-weight: bold; border-bottom: 1px solid #CCC">
                    Approve Course Certificate
                  </div>

                </div>



    <div class="row mx-2 mb-3" style="">
      <div class="col-1" style="padding-left: 0px;">
        <div class="progress-circle" >
          <img :src="certificates.image" width="50px" height="50px" />
        </div>
      </div>

      <div class="col-7 col-xl-8 pl-3" style="font-size: 15px; padding-top: 12px;">
        <p class="mb-0">{{ certificates.name }}</p>
      </div>
    </div>
                <div class="row align-items-center mb-3">
                  <div class="col-12" style="padding-right: 15px;">
                    <div class="px-2">
                      <div class="row">
                        <div class="col-5" >
                          <div class="dropbox" v-if="isPDF == 0">
                            <img :src="image" height="100px" />
                          </div>
                          <div class="dropbox1" v-if="isPDF == 1">
                            <p>
                            <div class="row pr-3" >
                              <div class="col-2 " style="padding-top: 0px; padding-left: 20px;">
                                <img class="" height="35px" src="@/assets/manager/Mentor Mentee Upload File.png"  />
                              </div>
                              <div class="col-8 pt-2">
                                <div class="col p-0" style="font-size: 15px; font-weight: bold;">{{ orgfileName }}</div>
                              </div>
                              </p>
                            </div>
                          </div>
                            <div class="row">
                            <div class="col branding_text_color text-center" @click="downloadFunc()" style="cursor: pointer;text-decoration: underline;">
                              <b>View Certificate</b>
                            </div>
                            </div>

                        </div>
                        <div class="col-7" >
                          <div class="row" v-if="loading == false">
                          <div class="col-6 text-align-right pt-1">
                            Issued Date: 
                          </div>
                          <div class="col-6 text-align-right pt-1">
                            {{ issued_date }}
                          </div>
                          </div>
                          <div class="row pt-1">
                          <div class="col-6 text-align-right pt-1">
                            Expiration Date: 
                          </div>
                          <div class="col-6 text-align-right pt-1">
                            {{ expiration_date }}
                          </div>
                          </div>
                          <div class="row pt-1">
                          <div class="col-12 text-align-right pt-1">
                            <textarea
                            name="remarks" 
                            v-model="remarks"
                            @keyup='charCount()'
                            placeholder="Remarks"
                            class="textarea col-xs-12 col-md-12 col-lg-12 padding-lr-5 input-height-25"
                            maxlength="500" style="height: 60px;">
                            </textarea>
                            <div class="text-align-right">Characters left: {{ totalcharacter }}</div>
                            
                          </div>
                          </div>
                          <div class="row pt-2 text-align-right" style="">
                            <div class="col-12 p-0" >
                              <div class="col-6 px-2 px-xl-3 float-right">
                              <a v-if="disable_add == true" href="#" class="col-9 float-right btn btn-primary rounded-pill border-0 text-white approve_btn d-block" >Approve</a>
                              <a v-else href="#" class="col-9 float-right btn btn-primary rounded-pill border-0 text-white approve_btn d-block" @click.prevent="onSubmit('Approved')">Approve</a>
                              <a href="#" class="col-7 branding_text_color float-right text-center mr-2 d-block" @click.prevent="onSubmit('Denied')">Deny</a>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';


const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  props: ['isModalVisible', 'type'],
  data() {
    return {
      uploadError: '',
      loading: false,
      currentStatus: null,
      uploadedFiles: [],
      menteeId: '',
      courseId: '',
      stepId: '',
      objectiveId: '',
      issued_date: '',
      expiration_date: '',
      verification_code: '',
      certificates: [],
      filename: '',
      disable_add: false,
      ref_pdf_file: {},
      remarks: '',
      isPDF: 0,
      image: '',
      menteeUploadCertificateId: '',
      orgfileName: '',
      totalcharacter: 500,
      menteeFirstName: '',
      menteeShortName: '',
      mentorsAssigned: [],
      pathwayStepsData: [],
      activeStep: '',

    }
  },
  computed: {

  },
  methods: {
        charCount: function() {
          this.totalcharacter = parseInt(500) - parseInt(this.remarks.length);
        },
    downloadFunc: function() {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/course_certificates/' + this.filename;
      window.open(url, '_blank');
      return false;    
    },
    hide() {
      this.$emit('closeMenteeApproveModal');
    },
    onSubmit(status) {
      this.disable_add = true;
              axios('/mentee-upload-course-certificate/' + this.menteeUploadCertificateId, {
                 method: 'PATCH',
                 data: { 
                  "status": status,
                  "remarks": this.remarks,
                 },

              })
              .then(resp => {
                this.hide();
              })
              .catch(error => {
                this.uploadError = error.response.data.message;
              })
    },

    getMenteeCertificatesData(menteeId, courseId, stepId, objectiveId) {
      this.menteeId = menteeId;
      this.loading = true;
      this.courseId = courseId;
      this.stepId = stepId;
      this.objectiveId = objectiveId;
      this.totalcharacter = 500;
      this.remarks = '';
      this.disable_add = false;
      axios('/desktop/get-mentee-repitition-lists-all-tasklists', {
        method: 'GET',
        params: {
          mentee_id: this.menteeId,
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.menteeFirstName = data.mentee_first_name;
        this.menteeShortName = data.mentee_short_name;
        this.repCount = data.rep_count;
        this.repTasks = data.rep_tasks;
        this.mentorsAssigned = data.mentors_assigned;
      })
      .catch(() => {});

      axios('/desktop/v2/pathway/get-mentee-pathway-progress', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: this.menteeId, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.pathwayStepsData = data;
        this.activeStep = this.pathwayStepsData.mentee_pathway.currentStep;
        this.pathwayId = this.pathwayStepsData.mentee_pathway.id;
        this.showFutureSteps = this.pathwayStepsData.mentee_pathway.showFutureSteps;
      })
      .catch(() => {});


      
        axios('/desktop/v2/get-mentee-upload-course-certification-details', {
          method: 'GET',
          params: {
            courseId: this.courseId,
            menteeId: this.menteeId,
            objectiveId: this.objectiveId,
          }
        })
        .then(resp => {
          this.loading = false;
          this.certificates = resp.data.certificates;
          this.issued_date = resp.data.issueDate;
          this.expiration_date = resp.data.expirationDate;
          if(this.expiration_date == '') {
            this.expiration_date = 'N/A';
          }
          this.verification_code = resp.data.verificationCode;
          if(this.verification_code == '') {
            this.verification_code = 'N/A';
          }
          this.filename = resp.data.fileName;
          this.isPDF = resp.data.isPDF;
          this.image = resp.data.image;
          this.menteeUploadCertificateId = resp.data.menteeUploadCertificateId;
          this.orgfileName = resp.data.orgfileName;
        })
        .catch(() => {});
      
      
      setTimeout(() => {
        let element = document.getElementById('groupModal15');    
        element.scrollIntoView(true);
      }, 2000); 
    },
  },
  components: {
    MenteePathwayProgress,
    DatePicker,
  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
@media (max-width: 1199.98px) {
  .progress_item_link {
    font-size: 13px;
    cursor: pointer;
  }
}
.progress_item_link {
  cursor: pointer;
}
.objective-view-icon {
  width: 15px;
  margin-left: 2px !important;
}
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.search_tasks_txtbox input:active,
.search_tasks_txtbox input:focus,
.search_tasks_txtbox input:hover {
  border-color: #ced4da !important;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
/* Upload Form CSS Start */
.dropbox {
  border: 0px dashed grey; /* the dash box */
  border-radius: 10px;
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 125px; /* minimum height */
  position: relative;
  text-align: center;
}
.dropbox1 {
  border: 0px solid grey; /* the dash box */
  border-radius: 10px;
  outline-offset: -10px;
  background: white;
  min-height: 80px;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: white; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
/* Upload Form CSS End */
.input-class  {
  border: 1px solid #002F42; 
  border-radius: 10px;
}
.mx-datepicker {
  width: auto;
}
.mx-datepicker .input-class {
  border-radius: 10px;
  padding-right: 25px;
  border: 1px solid #002F42; 
}
.text-white {
    color: #fff !important;
}
.text-white:hover {
    color: #fff !important;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}

</style>
<style>
.mx-datepicker .input-class {
  border-radius: 10px;
  padding-right: 25px;
  border: 1px solid #002F42; 
}
</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_approve_course_certificate.vue